module.exports = __webpack_public_path__ + "media/educators/printedMaterials-poster-qrg-transp@2x-e1eabb53.png";